import React, { useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { useNavigate } from "react-router-dom";
import { RollbackOutlined, DeleteOutlined } from "@ant-design/icons";
import { Layout, Col, Row, Select } from "antd";
import { Button, Card, Form, Spin, Badge, Avatar, Input } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { CREATE_FACILITY, IMAGE_BASE_URL } from "../../constants/api";
import ImageSelect from "../images/ImageSelect";
import { useForm, useWatch } from "antd/es/form/Form"; // Import useWatch

function FacilityAdd() {
  const { Content } = Layout;
  const { Option } = Select;
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = useForm();
  const selectedType = useWatch("type", form); // Watch 'type' value
  const [loading, setIsLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  // For Image Selection
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedFileValue, setSelectedFileValue] = useState(null);
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  const handleDialogOk = (selectedImage) => {
    if (selectedImage.length > 0) {
      setSelectedImage(selectedImage[0].id);
      setSelectedFileValue(selectedImage[0].filePath);
      form.setFieldsValue({ image: selectedImage[0].filePath });
      // console.log(selectedImage);
      // displayMessage(
      //   SUCCESS_MESSAGE,
      //   `Image ID: ${selectedImage[0].id}, Path: ${selectedImage[0].filePath}`
      // );
    } else {
      displayMessage(ERROR_MSG_TYPE, "Image not selected");
    }
  };

  const removeSelectedImage = () => {
    setSelectedImage("");
    setSelectedFileValue(null);
    form.setFieldsValue({ image: "" });
  };

  const createData = (values) => {
    setIsLoading(true);
    const data = new FormData();
    data.append("title", values.title);
    data.append("description", values.description);
    data.append("type", values.type);
    data.append("slug", values.slug);
    if (values.location) {
      data.append("location", values.location);
    }
    if (values.distance) {
      data.append("distance", values.distance);
    }
    if (selectedImage) {
      data.append("image", selectedImage);
    }
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/facility");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Save Data");
    };
    postAPI(CREATE_FACILITY, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Create Facility"
            bordered={false}
            extra={
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loading}>
              <Form form={form} layout="vertical" onFinish={createData}>
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      name="title"
                      label="Title"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Title" />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name="type"
                      label="Type"
                      rules={[
                        {
                          required: true,
                          message: "Please select the type",
                        },
                      ]}
                    >
                      <Select placeholder="Select Type">
                        <Option value="page">Page</Option>
                        <Option value="room">Room</Option>
                        <Option value="nearby">Nearby Attractions</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  {selectedType === "nearby" ? (
                    <Col span={6}>
                      <Form.Item name="location" label="Location">
                        <Input type={"text"} placeholder="Location" />
                      </Form.Item>
                    </Col>
                  ) : null}
                  {selectedType === "nearby" ? (
                    <Col span={6}>
                      <Form.Item name="distance" label="Distance">
                        <Input type={"text"} placeholder="Distance" />
                      </Form.Item>
                    </Col>
                  ) : null}
                  <Col span={12}>
                    <Form.Item
                      name="description"
                      label="Description"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Description" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      type="file"
                      name="image"
                      label="Image"
                      rules={[{ required: true }]}
                    >
                      <Row>
                        <Col span={selectedImage === "" ? 24 : 15} offset={0}>
                          <Input
                            type="text"
                            readOnly
                            onClick={openDialog}
                            value={
                              selectedImage === ""
                                ? "Click to upload image"
                                : selectedImage
                            }
                            name="myImage"
                            placeholder="Image"
                          />
                        </Col>

                        {selectedImage !== "" ? (
                          <Col span={3} offset={1}>
                            <Badge>
                              <Avatar
                                src={IMAGE_BASE_URL + selectedFileValue}
                                shape="circle"
                                size="default"
                              />
                            </Badge>
                            <DeleteOutlined onClick={removeSelectedImage} />
                          </Col>
                        ) : null}
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Submit
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
        <ImageSelect
          isOpen={isDialogOpen}
          onClose={closeDialog}
          onOk={handleDialogOk}
          fromMager={false}
        />
      </Layout>
    </>
  );
}
export default FacilityAdd;
